<div class="row col-md-12">
    <!-- Loan Section -->
    <div class="Maincard col-md-12">
        <div class="Maincard-header">
            <div class="icon-box blue">
                <svg width="800px" height="800px" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg"
                    stroke-width="3" stroke="#000000" fill="none">
                    <path
                        d="M15.08,52.89,8.27,42.64a1.1,1.1,0,0,1,.32-1.53l4.29-2.79a1.11,1.11,0,0,1,1.51.3l7,10.06a1.1,1.1,0,0,1-.29,1.54l-4.44,3A1.1,1.1,0,0,1,15.08,52.89Z"
                        stroke-linecap="round" />
                    <path
                        d="M15.16,39.69l7.17-4.51a2,2,0,0,1,1.56-.24c2.54.65,10.2,2.76,13,3.74,2.13.75,3,2.84,2.13,4.23-1.16,1.86-2.92,1.65-4.19,1.3a4.29,4.29,0,0,1-.5-.19l-5-2.13"
                        stroke-linecap="round" />
                    <path
                        d="M20.72,47.82l2.34-1.34,13.26,3.63a1,1,0,0,0,.81-.13C39,48.78,47,43.49,50.94,40.7A2.2,2.2,0,0,0,51.22,37a2.86,2.86,0,0,0-3.41-.3c-1.39.77-5.22,3.62-5.22,3.62"
                        stroke-linecap="round" />
                    <circle cx="38.09" cy="20.44" r="13" stroke-linecap="round" />
                    <path
                        d="M33.81,13.85h2.08c2,0,4.26.67,4.26,3.76,0,3.35-2.84,4.63-5.85,4.29a.17.17,0,0,0-.14.29l6.4,6.89"
                        stroke-linecap="round" />
                    <line x1="42.6" y1="13.85" x2="35.43" y2="13.85" stroke-linecap="round" />
                    <line x1="33.92" y1="17.72" x2="42.65" y2="17.72" stroke-linecap="round" />
                </svg>
            </div>
            <div>
                <p class="Maincard-title">Loan</p>
                <p class="card-subtitle">Loan voucher management</p>
            </div>
        </div>
        <div class="row d-flex justify-content-between align-items-center mt-2 mb-2">
            <div class="col">
                <div class="card">
                    <div class="card-header">
                        <div class="icon-box green">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke-width="1.8"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path d="M17 1l4 4-4 4" />
                                <path d="M3 11V9a4 4 0 014-4h14" />
                                <path d="M7 23l-4-4 4-4" />
                                <path d="M21 13v2a4 4 0 01-4 4H3" />
                            </svg>
                        </div>
                        <div>
                            <p class="card-title">Receipt</p>
                        </div>
                    </div>
                    <div class="card-body">
                        <button type="button" class="voucher-btn" (click)="OpenModel('ReceiptLoan')">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                                <polyline points="17 8 12 3 7 8" />
                                <line x1="12" y1="3" x2="12" y2="15" />
                            </svg>
                            Generate Voucher — Import
                        </button>
                        <button type="button" class="voucher-btn" (click)="exportExcel('ReceiptLoan')">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                                <polyline points="7 10 12 15 17 10" />
                                <line x1="12" y1="15" x2="12" y2="3" />
                            </svg>
                            Generate Voucher — Export Template
                        </button>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="card">
                    <div class="card-header">
                        <div class="icon-box blue">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke-width="1.8"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                                <polyline points="7 10 12 15 17 10" />
                                <line x1="12" y1="15" x2="12" y2="3" />
                            </svg>
                        </div>
                        <div>
                            <p class="card-title">Payment</p>
                        </div>
                    </div>
                    <div class="card-body">
                        <button type="button" class="voucher-btn" (click)="OpenModel('PaymentLoanToAccount')">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                                <polyline points="17 8 12 3 7 8" />
                                <line x1="12" y1="3" x2="12" y2="15" />
                            </svg>
                            Generate Voucher — Import
                        </button>
                        <button type="button" class="voucher-btn" (click)="exportExcel('PaymentLoanToAccount')">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                                <polyline points="7 10 12 15 17 10" />
                                <line x1="12" y1="15" x2="12" y2="3" />
                            </svg>
                            Generate Voucher — Export Template
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row d-flex justify-content-between align-items-center mt-2 mb-2">
            <div class="col">
                <div class="card">
                    <div class="card-header">
                        <div class="icon-box blue">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke-width="1.8"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
                                <polyline points="9 22 9 12 15 12 15 22" />
                            </svg>
                        </div>
                        <div>
                            <p class="card-title">Journal</p>
                            <p class="card-subtitle">Loan to accounts</p>
                        </div>
                    </div>
                    <div class="card-body">
                        <button type="button" class="voucher-btn" (click)="OpenModel('LoanToAccount')">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                                <polyline points="17 8 12 3 7 8" />
                                <line x1="12" y1="3" x2="12" y2="15" />
                            </svg>
                            Generate Voucher — Import
                        </button>
                        <button type="button" class="voucher-btn" (click)="exportExcel('LoanToAccount')">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                                <polyline points="7 10 12 15 17 10" />
                                <line x1="12" y1="15" x2="12" y2="3" />
                            </svg>
                            Generate Voucher — Export Template
                        </button>
                    </div>
                </div>
            </div>
            <div class="col">
            </div>
        </div>
    </div>

    <!-- Accounts Section -->
    <!-- <div class="Maincard col-md-12 mt-2">
        <div class="Maincard-header">
            <div class="icon-box blue">
                <svg width="800px" height="800px" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M5.49707 3C4.11636 3 2.99707 4.11929 2.99707 5.5V14.5C2.99707 15.8807 4.11636 17 5.49707 17H10.1606C10.0616 16.6844 10.0062 16.35 10.0005 16H5.49707C4.66864 16 3.99707 15.3284 3.99707 14.5V7H17V6H16.9971V5.5C16.9971 4.11929 15.8778 3 14.4971 3H5.49707ZM15.9971 5.5V6H3.99707V5.5C3.99707 4.67157 4.66864 4 5.49707 4H14.4971C15.3255 4 15.9971 4.67157 15.9971 5.5Z"
                        fill="#212121" />
                    <path
                        d="M15 12C14.1716 12 13.5 11.3284 13.5 10.5C13.5 9.67157 14.1716 9 15 9H17.0002C16.5441 8.39278 15.8179 8 15 8C13.6193 8 12.5 9.11929 12.5 10.5C12.5 11.8807 13.6193 13 15 13C15.8179 13 16.5441 12.6072 17.0002 12H15Z"
                        fill="#212121" />
                    <path
                        d="M12.55 15C12.4351 15 12.3001 15.0597 12.1812 15.1934C12.0603 15.3293 12 15.4946 12 15.62V15.94C12 16.829 12.9702 18 15 18H17.9878C17.2799 18.6082 16.2407 19 15 19C12.6332 19 11 17.5744 11 15.94V15.62C11 15.2151 11.1747 14.8204 11.4339 14.5289C11.695 14.2352 12.085 14 12.55 14H17.45C17.915 14 18.305 14.2352 18.5661 14.5289C18.6882 14.6663 18.7916 14.8266 18.8668 15H12.55Z"
                        fill="#212121" />
                    <path
                        d="M17.5 10.5C17.5 10.6712 17.4828 10.8384 17.45 11H15V10H17.45C17.4828 10.1616 17.5 10.3288 17.5 10.5Z"
                        fill="#212121" />
                    <path d="M15 17H18.7611C18.9085 16.6847 18.9908 16.3474 18.9993 16H15V17Z" fill="#212121" />
                </svg>
            </div>
            <div>
                <p class="Maincard-title">Accounts</p>
                <p class="card-subtitle">Accounts voucher management</p>
            </div>
        </div>
        <div class="row d-flex justify-content-between align-items-center mt-2 mb-2">
            <div class="col">
                <div class="card">
                    <div class="card-header">
                        <div class="icon-box green">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke-width="1.8"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path d="M17 1l4 4-4 4" />
                                <path d="M3 11V9a4 4 0 014-4h14" />
                                <path d="M7 23l-4-4 4-4" />
                                <path d="M21 13v2a4 4 0 01-4 4H3" />
                            </svg>
                        </div>
                        <div>
                            <p class="card-title">Receipt</p>
                        </div>
                    </div>
                    <div class="card-body">
                        <button type="button" class="voucher-btn" (click)="OpenModel('ReceiptAccountToAccount')">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                                <polyline points="17 8 12 3 7 8" />
                                <line x1="12" y1="3" x2="12" y2="15" />
                            </svg>
                            Generate Voucher — Import
                        </button>
                        <button type="button" class="voucher-btn" (click)="exportExcel('ReceiptAccountToAccount')">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                                <polyline points="7 10 12 15 17 10" />
                                <line x1="12" y1="15" x2="12" y2="3" />
                            </svg>
                            Generate Voucher — Export Template
                        </button>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="card">
                    <div class="card-header">
                        <div class="icon-box green">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke-width="1.8"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path d="M17 1l4 4-4 4" />
                                <path d="M3 11V9a4 4 0 014-4h14" />
                                <path d="M7 23l-4-4 4-4" />
                                <path d="M21 13v2a4 4 0 01-4 4H3" />
                            </svg>
                        </div>
                        <div>
                            <p class="card-title">Payment</p>
                        </div>
                    </div>
                    <div class="card-body">
                        <button type="button" class="voucher-btn" (click)="OpenModel('PaymentAccountToAccount')">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                                <polyline points="17 8 12 3 7 8" />
                                <line x1="12" y1="3" x2="12" y2="15" />
                            </svg>
                            Generate Voucher — Import
                        </button>
                        <button type="button" class="voucher-btn" (click)="exportExcel('PaymentAccountToAccount')">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                                <polyline points="7 10 12 15 17 10" />
                                <line x1="12" y1="15" x2="12" y2="3" />
                            </svg>
                            Generate Voucher — Export Template
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row d-flex justify-content-between align-items-center mt-2 mb-2">
            <div class="col">
                <div class="card">
                    <div class="card-header">
                        <div class="icon-box blue">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke-width="1.8"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
                                <polyline points="9 22 9 12 15 12 15 22" />
                            </svg>
                        </div>
                        <div>
                            <p class="card-title">Journal</p>
                        </div>
                    </div>
                    <div class="card-body">
                        <button type="button" class="voucher-btn" (click)="OpenModel('AccountToAccount')">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                                <polyline points="17 8 12 3 7 8" />
                                <line x1="12" y1="3" x2="12" y2="15" />
                            </svg>
                            Generate Voucher — Import
                        </button>
                        <button type="button" class="voucher-btn" (click)="exportExcel('AccountToAccount')">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                                <polyline points="7 10 12 15 17 10" />
                                <line x1="12" y1="15" x2="12" y2="3" />
                            </svg>
                            Generate Voucher — Export Template
                        </button>
                    </div>
                </div>
            </div>
            <div class="col"></div>
        </div>
    </div> -->

    <!-- Partner Section (unchanged, as requested) -->
    <div class="Maincard col-md-12 mt-2">
        <div class="Maincard-header">
            <div class="icon-box blue">
                <svg width="800px" height="800px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink">
                    <title>ic_fluent_payment_24_regular</title>
                    <desc>Created with Sketch.</desc>
                    <g id="🔍-Product-Icons" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="ic_fluent_payment_24_regular" fill="#212121" fill-rule="nonzero">
                            <path
                                d="M19.2388849,5.0207074 C20.7014167,5.0207074 21.8972891,6.162412 21.9838661,7.60318507 L21.9888849,7.7707074 L21.9888849,16.275793 C21.9888849,17.7383249 20.8471803,18.9341973 19.4064072,19.0207742 L19.2388849,19.025793 L4.76104885,19.025793 C3.29851702,19.025793 2.10264457,17.8840884 2.01606765,16.4433154 L2.01104885,16.275793 L2.01104885,7.7707074 C2.01104885,6.30817556 3.15275345,5.11230312 4.59352652,5.02572619 L4.76104885,5.0207074 L19.2388849,5.0207074 Z M20.4880489,10.9947074 L3.51004885,10.9947074 L3.51104885,16.275793 C3.51104885,16.9230017 4.00292352,17.4553269 4.63324361,17.5193394 L4.76104885,17.525793 L19.2388849,17.525793 C19.8860935,17.525793 20.4184188,17.0339184 20.4824312,16.4035983 L20.4888849,16.275793 L20.4880489,10.9947074 Z M18.2529045,14.5 C18.6671181,14.5 19.0029045,14.8357864 19.0029045,15.25 C19.0029045,15.6296958 18.7207506,15.943491 18.3546751,15.9931534 L18.2529045,16 L15.7529045,16 C15.3386909,16 15.0029045,15.6642136 15.0029045,15.25 C15.0029045,14.8703042 15.2850584,14.556509 15.6511339,14.5068466 L15.7529045,14.5 L18.2529045,14.5 Z M19.2388849,6.5207074 L4.76104885,6.5207074 C4.11384016,6.5207074 3.58151495,7.01258206 3.51750246,7.64290216 L3.51104885,7.7707074 L3.51004885,9.4947074 L20.4880489,9.4947074 L20.4888849,7.7707074 C20.4888849,7.12349871 19.9970102,6.5911735 19.3666901,6.52716101 L19.2388849,6.5207074 Z"
                                id="🎨-Color" />
                        </g>
                    </g>
                </svg>
            </div>
            <div>
                <p class="Maincard-title">Partner</p>
                <p class="card-subtitle">Partner voucher management</p>
            </div>
        </div>
        <div class="row d-flex justify-content-between align-items-center mt-2 mb-2">
            <div class="col">
                <div class="card">
                    <div class="card-header">
                        <div class="icon-box blue">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke-width="1.8"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                                <polyline points="7 10 12 15 17 10" />
                                <line x1="12" y1="15" x2="12" y2="3" />
                            </svg>
                        </div>
                        <div>
                            <p class="card-title">Receipt</p>
                        </div>
                    </div>
                    <div class="card-body">
                        <button type="button" class="voucher-btn" (click)="OpenModel('PartnerReceipt')">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                                <polyline points="17 8 12 3 7 8" />
                                <line x1="12" y1="3" x2="12" y2="15" />
                            </svg>
                            Generate Voucher — Import
                        </button>
                        <button type="button" class="voucher-btn" (click)="exportExcel('PartnerReceipt')">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                                <polyline points="7 10 12 15 17 10" />
                                <line x1="12" y1="15" x2="12" y2="3" />
                            </svg>
                            Generate Voucher — Export Template
                        </button>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="card">
                    <div class="card-header">
                        <div class="icon-box green">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke-width="1.8"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path d="M17 1l4 4-4 4" />
                                <path d="M3 11V9a4 4 0 014-4h14" />
                                <path d="M7 23l-4-4 4-4" />
                                <path d="M21 13v2a4 4 0 01-4 4H3" />
                            </svg>
                        </div>
                        <div>
                            <p class="card-title">Payment</p>
                        </div>
                    </div>
                    <div class="card-body">
                        <button type="button" class="voucher-btn" (click)="OpenModel('PartnerPayment')">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                                <polyline points="17 8 12 3 7 8" />
                                <line x1="12" y1="3" x2="12" y2="15" />
                            </svg>
                            Generate Voucher — Import
                        </button>
                        <button type="button" class="voucher-btn" (click)="exportExcel('PartnerPayment')">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                                <polyline points="7 10 12 15 17 10" />
                                <line x1="12" y1="15" x2="12" y2="3" />
                            </svg>
                            Generate Voucher — Export Template
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row d-flex justify-content-between align-items-center mt-2 mb-2">
            <div class="col">
                <div class="card">
                    <div class="card-header">
                        <div class="icon-box blue">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke-width="1.8"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                                <polyline points="7 10 12 15 17 10" />
                                <line x1="12" y1="15" x2="12" y2="3" />
                            </svg>
                        </div>
                        <div>
                            <p class="card-title">Journal</p>
                            <p class="card-subtitle">Partner Loan to account</p>
                        </div>
                    </div>
                    <div class="card-body">
                        <button type="button" class="voucher-btn" (click)="OpenModel('PartnerJournalLoanToAccount')">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                                <polyline points="17 8 12 3 7 8" />
                                <line x1="12" y1="3" x2="12" y2="15" />
                            </svg>
                            Generate Voucher — Import
                        </button>
                        <button type="button" class="voucher-btn" (click)="exportExcel('PartnerJournalLoanToAccount')">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                                <polyline points="7 10 12 15 17 10" />
                                <line x1="12" y1="15" x2="12" y2="3" />
                            </svg>
                            Generate Voucher — Export Template
                        </button>
                    </div>
                </div>
            </div>
            <div class="col">

            </div>
        </div>
    </div>

    <div class="modal fade in" id="bulkImportModel" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
        data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
                <div cdkDragHandle class="modal-header" style="padding: 10px">
                    <h6 class="modal-title">{{ modalTitle }}</h6>
                    <button type="button" (click)="onClose()" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true"><i class="far text-black fa-times-circle"></i></span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="d-flex flex-column justify-content-center align-items-center col-md-12">
                        <form #f="ngForm" class="ml-2 col-md-12" novalidate>
                            <div class="row mt-2 col-md-12 p-0 formborder">
                                <!-- Voucher Date (common) -->
                                <div class="col-md-3">
                                    <span class="required-lable">Voucher Date</span>
                                    <div class="datepicker_feild">
                                        <input [matDatepicker]="picker4" dateConvert placeholder="DD/MM/YYYY"
                                            name="VoucherDate" [(ngModel)]="VoucherDate" #refVoucherDate="ngModel"
                                            class="form-control input-text-css" required [max]="ToDate" [ngClass]="{
                                            'is-invalid': f.submitted && refVoucherDate.invalid,
                                            'alert-warning': refVoucherDate.invalid &&
                                            (refVoucherDate.dirty || refVoucherDate.touched || refVoucherDate.untouched)
                                        }" />
                                        <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
                                        <mat-datepicker #picker4></mat-datepicker>
                                    </div>
                                </div>

                                <ng-container
                                    *ngIf="mode === 'LoanToAccount' || mode === 'PartnerJournalLoanToAccount'">
                                    <div class="col-md-3">
                                        <div class="col-md-12 p-0" style="padding-left: 10px;"><span
                                                class="required-lable">Type</span></div>
                                        <div class="col-md-12 p-0" style="padding-left: 10px;">
                                            <select name="Type" id="Type" required [(ngModel)]="Type"
                                                class="form-control input-text-css" #refType="ngModel" [ngClass]="{
                                                'is-invalid': f.submitted && refType.invalid,
                                                'alert-warning': refType.invalid && (refType.dirty || refType.touched || refType.untouched)
                                            }">
                                                <option value="CR">Credit</option>
                                                <option value="DR">Debit</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="col-md-12 p-0" style="padding-left: 10px;"><span
                                                class="required-lable">Account</span></div>
                                        <div class="col-md-12 p-0" style="padding-left: 10px;">
                                            <select name="Account_HeadId" id="Account_HeadId" required
                                                [(ngModel)]="Account_HeadId" class="form-control input-text-css"
                                                #refAccount_HeadId="ngModel" [ngClass]="{
                                                'is-invalid': f.submitted && refAccount_HeadId.invalid,
                                                'alert-warning': refAccount_HeadId.invalid && (refAccount_HeadId.dirty || refAccount_HeadId.touched || refAccount_HeadId.untouched)
                                            }">
                                                <option value="">Select Account</option>
                                                <option *ngFor="let ca of accountHeadDropdown" [value]="ca.AccountId">
                                                    {{ ca.Account_Name }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <span class="required-lable"> Branch</span>
                                        <select name="BranchId" id="BranchId" #refBranchId="ngModel"
                                            [(ngModel)]="BranchId" class="form-control input-text-css" required
                                            [ngClass]="{
                                            'is-invalid': f.submitted && refBranchId.invalid,
                                            'alert-warning': refBranchId.invalid && (refBranchId.dirty || refBranchId.touched || refBranchId.untouched)
                                        }">
                                            <option value="">Select Branch</option>
                                            <option *ngFor="let branch of BranchesList" [value]="branch.BranchId">
                                                {{ branch.Branch_Name }}
                                            </option>
                                        </select>
                                    </div>
                                </ng-container>
                                <!-- Receipt Loan specific fields -->
                                <ng-container *ngIf="mode === 'ReceiptLoan' ||
                      mode === 'PaymentLoanToAccount' ||
                      mode === 'PartnerReceipt' || mode === 'PartnerPayment'">
                                    <div class="col-md-3">
                                        <span class="required-lable">Bank/Cash</span>
                                        <select name="Voucher_Tag" required [(ngModel)]="Voucher_Tag"
                                            (change)="Get_Acc_Accounts_By_Tag()" #refVoucher_Tag="ngModel"
                                            class="form-control input-text-css"
                                            [ngClass]="{'is-invalid': f.submitted && refVoucher_Tag.invalid,
                        'alert-warning': refVoucher_Tag.invalid && (refVoucher_Tag.dirty || refVoucher_Tag.touched || refVoucher_Tag.untouched)}">
                                            <option value="">Select Type</option>
                                            <option value="Bank">Bank</option>
                                            <option value="CASH">Cash</option>
                                        </select>
                                    </div>

                                    <div class="col-md-3">
                                        <span class="required-lable">Select Account</span>
                                        <select name="DRAccountId" required [(ngModel)]="DRAccountId"
                                            #refDRAccountId="ngModel" class="form-control input-text-css"
                                            [ngClass]="{'is-invalid': f.submitted && refDRAccountId.invalid,
                        'alert-warning': refDRAccountId.invalid && (refDRAccountId.dirty || refDRAccountId.touched || refDRAccountId.untouched)}">
                                            <option value="">Select Account</option>
                                            <option *ngFor="let data of accountTagDropdown" [value]="data.AccountId">{{
                                                data.Account_Name }}</option>
                                        </select>
                                    </div>
                                </ng-container>

                                <!-- Remarks (common) -->
                                <!-- <div class="col-md-8 p-0">
                                    <div class="col-md-12" style="padding-left: 10px;"><span
                                            class="required-lable">Remarks</span></div>
                                    <div class="col-md-12" style="padding-left: 10px;">
                                        <textarea name="Remarks" id="Remarks" required [(ngModel)]="Remarks"
                                            class="form-control input-text-css" #refRemarks="ngModel" [ngClass]="{
                                            'is-invalid': f.submitted && refRemarks.invalid,
                                            'alert-warning': refRemarks.invalid && (refRemarks.dirty || refRemarks.touched || refRemarks.untouched)
                                        }" placeholder="Remark..." rows="1"></textarea>
                                    </div>
                                </div> -->

                                <div class="col-md-3 text-center" [hidden]="!f.form.valid">
                                    <span class="button-wrap">
                                        <label class="mt-3 voucher-btn" for="bulkImport">
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                                                stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round">
                                                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                                                <polyline points="17 8 12 3 7 8" />
                                                <line x1="12" y1="3" x2="12" y2="15" />
                                            </svg>
                                            Import</label>
                                        <input type="file" id="bulkImport" (change)="importExcel($event)" accept=".xlsx"
                                            style="display: none;" [disabled]="!f.form.valid" />
                                    </span>
                                </div>
                            </div>
                        </form>

                        <!-- Unmatched Data Table (same as before) -->
                        <div *ngIf="dataSourceUnmatched" class="col-md-12 p-0 mt-2">
                            <h6 class="mb-2">Unmatched Data</h6>
                            <div class="table-responsive"
                                style="margin-top: 20px; height: fit-content; overflow: auto; border: 1px solid #dc3545;">
                                <mat-table [dataSource]="dataSourceUnmatched" matSort>
                                    <ng-container matColumnDef="Id">
                                        <mat-header-cell *matHeaderCellDef class="grid-header">#</mat-header-cell>
                                        <mat-cell *matCellDef="let row, let i = index"
                                            class="grid-cell">{{i+1}}</mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="LoanNo">
                                        <mat-header-cell *matHeaderCellDef class="grid-header">
                                            {{ (mode === 'PartnerReceipt' || mode === 'PartnerPayment' ||
                                            mode === 'PartnerJournalLoanToLoan') ? 'Partner_LoanNo' : 'LoanNo' }}
                                        </mat-header-cell>
                                        <mat-cell *matCellDef="let row" class="grid-cell">{{ row.LoanNo }}</mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="AccountHead"
                                        *ngIf="mode === 'AccountToAccount' || mode === 'ReceiptAccountToAccount'">
                                        <mat-header-cell *matHeaderCellDef class="grid-header">Account
                                            Head</mat-header-cell>
                                        <mat-cell *matCellDef="let row" class="grid-cell">{{ row.AccountHead
                                            }}</mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="ErrorReason">
                                        <mat-header-cell *matHeaderCellDef class="grid-header">Error
                                            Reason</mat-header-cell>
                                        <mat-cell *matCellDef="let row" class="grid-cell">{{ row.ErrorReason
                                            }}</mat-cell>
                                    </ng-container>
                                    <mat-header-row *matHeaderRowDef="UnmatcheddisplayedColumns"></mat-header-row>
                                    <mat-row *matRowDef="let row; columns: UnmatcheddisplayedColumns"></mat-row>
                                </mat-table>
                            </div>

                        </div>

                        <!-- UI Validation Table -->
                        <div *ngIf="UIValidationFailed?.length > 0" class="col-md-12">
                            <h6 class="text-danger" *ngIf="UIValidationFailed[0]?.maxRowLimitError">Max row of data import is 50! Please remove extra rows.</h6>
                            <h6 class="text-danger" *ngIf="!UIValidationFailed[0]?.maxRowLimitError">UI Validation Failed - Correct Red Cells</h6>
                            <div class="table-responsive mt-3"
                                style="height: fit-content; overflow: auto; border: 1px solid #dc3545;">

                                <mat-table [dataSource]="dataSourceUIValidation" matSort>

                                    <!-- Id -->
                                    <ng-container matColumnDef="Id">
                                        <mat-header-cell *matHeaderCellDef class="grid-header">#</mat-header-cell>
                                        <mat-cell *matCellDef="let row" class="grid-cell">{{ row.Id }}</mat-cell>
                                    </ng-container>

                                    <!-- LoanNo / Partner_LoanNo -->
                                    <ng-container matColumnDef="LoanNo" *ngIf="mode !== 'AccountToAccount'">
                                        <mat-header-cell *matHeaderCellDef class="grid-header">
                                            {{ (mode === 'PartnerReceipt' || mode === 'PartnerPayment' ||
                                            mode === 'PartnerJournalLoanToLoan')
                                            ? 'Partner_LoanNo' : 'LoanNo' }}
                                        </mat-header-cell>
                                        <mat-cell *matCellDef="let row" class="grid-cell"
                                            [style.background-color]="row.loanNoError ? '#ffcccc' : 'transparent'">
                                            {{ row.LoanNo }}
                                        </mat-cell>
                                    </ng-container>

                                    <!-- Amount -->
                                    <ng-container matColumnDef="Amount">
                                        <mat-header-cell *matHeaderCellDef class="grid-header">Amount</mat-header-cell>
                                        <mat-cell *matCellDef="let row" class="grid-cell"
                                            [style.background-color]="row.amountError ? '#ffcccc' : 'transparent'">
                                            {{ row.Amount }}
                                        </mat-cell>
                                    </ng-container>

                                    <!-- ChargesHead -->
                                    <ng-container matColumnDef="ChargesHead" *ngIf="mode !== 'AccountToAccount'">
                                        <mat-header-cell *matHeaderCellDef class="grid-header">Charges
                                            Head</mat-header-cell>
                                        <mat-cell *matCellDef="let row" class="grid-cell"
                                            [style.background-color]="row.chargesHeadError ? '#ffcccc' : 'transparent'">
                                            {{ row.ChargesHead }}
                                        </mat-cell>
                                    </ng-container>

                                    <!-- PaymentMode -->
                                    <ng-container matColumnDef="PaymentMode" *ngIf="mode === 'ReceiptLoan' || mode === 'PaymentLoanToAccount' || 
                       mode === 'PartnerReceipt' || mode === 'PartnerPayment'">
                                        <mat-header-cell *matHeaderCellDef class="grid-header">Payment
                                            Mode</mat-header-cell>
                                        <mat-cell *matCellDef="let row" class="grid-cell"
                                            [style.background-color]="row.paymentModeError ? '#ffcccc' : 'transparent'">
                                            {{ row.PaymentMode }}
                                        </mat-cell>
                                    </ng-container>

                                    <!-- RefNo - NEW COLUMN -->
                                    <ng-container matColumnDef="RefNo" *ngIf="mode === 'ReceiptLoan' || mode === 'PaymentLoanToAccount' || 
                       mode === 'PartnerReceipt' || mode === 'PartnerPayment' || 
                       mode === 'ReceiptAccountToAccount'">
                                        <mat-header-cell *matHeaderCellDef class="grid-header">Ref No</mat-header-cell>
                                        <mat-cell *matCellDef="let row" class="grid-cell"
                                            [style.background-color]="row.refNoDuplicateError ? '#ffcccc' : 'transparent'">
                                            {{ row.RefNo || '' }}
                                        </mat-cell>
                                    </ng-container>

                                    <!-- TransType -->
                                    <ng-container matColumnDef="TransType"
                                        *ngIf="mode === 'LoanToLoan' || mode === 'AccountToAccount'">
                                        <mat-header-cell *matHeaderCellDef class="grid-header">Trans
                                            Type</mat-header-cell>
                                        <mat-cell *matCellDef="let row" class="grid-cell"
                                            [style.background-color]="row.transTypeError ? '#ffcccc' : 'transparent'">
                                            {{ row.TransType }}
                                        </mat-cell>
                                    </ng-container>

                                    <!-- BranchName -->
                                    <ng-container matColumnDef="BranchName"
                                        *ngIf="mode === 'AccountToAccount' || mode === 'ReceiptAccountToAccount'">
                                        <mat-header-cell *matHeaderCellDef class="grid-header">Branch</mat-header-cell>
                                        <mat-cell *matCellDef="let row" class="grid-cell"
                                            [style.background-color]="row.branchError ? '#ffcccc' : 'transparent'">
                                            {{ row.BranchName }}
                                        </mat-cell>
                                    </ng-container>

                                    <!-- Voucher_Narration -->
                                    <ng-container matColumnDef="Voucher_Narration" *ngIf="mode === 'ReceiptLoan' || mode === 'PartnerReceipt' || mode === 'LoanToAccount' || mode === 'PartnerJournalLoanToAccount'">
                                        <mat-header-cell *matHeaderCellDef class="grid-header">Narration</mat-header-cell>
                                        <mat-cell *matCellDef="let row" class="grid-cell">
                                            {{ row.Voucher_Narration || '' }}
                                        </mat-cell>
                                    </ng-container>

                                    <mat-header-row *matHeaderRowDef="displayedColumnsUIValidation"></mat-header-row>
                                    <mat-row *matRowDef="let row; columns: displayedColumnsUIValidation"></mat-row>
                                </mat-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Voucher Detail Modal (unchanged) -->
    <div class="modal fade in " id="voucherDetailModel" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
        data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
        <form #f="ngForm" novalidate>
            <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
                <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
                    <div cdkDragHandle class="modal-header" style="padding: 2px; border: none">
                        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
                            Voucher Detail
                        </h6>
                        <button type="button" (click)="OnCloseVoucher()" class="close" aria-label="Close">
                            <span aria-hidden="true"><i class="far text-black fa-times-circle"></i></span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row m-0 text-left">
                            <div class="col-md-12 bg-success1">
                                Voucher Type -
                                <span style="color: #fff; font-weight: bold">{{ voucherMasterdata?.Voucher_Type }} -
                                    {{ voucherMasterdata?.Voucher_Sub_Type }}</span>
                            </div>
                        </div>
                        <div class="row m-0 mt-1 text-left">
                            <div class="col-md-3 p-1" style="color: black">
                                <B class="fs-12">Voucher Date : </B>
                                {{ voucherMasterdata?.Voucher_Date }}
                            </div>
                        </div>
                        <div class="row m-0">
                            <div class="col-md-12 p-1">
                                <div class="table-responsive" *ngIf="
                  voucherMasterdata?.Voucher_Sub_Type == 'Loan' ||
                  voucherMasterdata?.Voucher_Sub_Type == 'Partner'
                ">
                                    <mat-table [dataSource]="dataSourceVoucher" matSort matTableExporter>
                                        <ng-container matColumnDef="Type">
                                            <mat-header-cell class="grid-header" *matHeaderCellDef
                                                style="max-width: 5%">Type</mat-header-cell>
                                            <mat-cell *matCellDef="let row" class="grid-cell" style="max-width: 5%">{{
                                                row.TranType
                                                }}</mat-cell>
                                            <mat-footer-cell *matFooterCellDef style="max-width: 5%"></mat-footer-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="CaseNo">
                                            <mat-header-cell class="grid-header" *matHeaderCellDef
                                                style="max-width: 15%">Case
                                                No</mat-header-cell>
                                            <mat-cell *matCellDef="let row" class="grid-cell" style="max-width: 15%">{{
                                                row.CaseNo }}</mat-cell>
                                            <mat-footer-cell *matFooterCellDef style="max-width: 15%"></mat-footer-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="Customer">
                                            <mat-header-cell class="grid-header" *matHeaderCellDef
                                                style="max-width: 10%">Customer</mat-header-cell>
                                            <mat-cell *matCellDef="let row" class="grid-cell" style="max-width: 10%">{{
                                                row.Customer
                                                }}</mat-cell>
                                            <mat-footer-cell *matFooterCellDef style="max-width: 10%"></mat-footer-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="Branch">
                                            <mat-header-cell class="grid-header" *matHeaderCellDef
                                                style="max-width: 10%">Branch</mat-header-cell>
                                            <mat-cell *matCellDef="let row" class="grid-cell" style="max-width: 10%">{{
                                                row.Branch_Name
                                                }}</mat-cell>
                                            <mat-footer-cell *matFooterCellDef style="max-width: 10%"></mat-footer-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="Category">
                                            <mat-header-cell class="grid-header" *matHeaderCellDef
                                                style="max-width: 20%">Category</mat-header-cell>
                                            <mat-cell *matCellDef="let row" class="grid-cell" style="max-width: 20%">{{
                                                row.ChagesHead
                                                }}</mat-cell>
                                            <mat-footer-cell *matFooterCellDef style="max-width: 20%"></mat-footer-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="AccountHead">
                                            <mat-header-cell class="grid-header" *matHeaderCellDef
                                                style="max-width: 20%">Account
                                                Head</mat-header-cell>
                                            <mat-cell *matCellDef="let row" class="grid-cell" style="max-width: 20%">{{
                                                row.ChargeHeadCategory
                                                }}</mat-cell>
                                            <mat-footer-cell *matFooterCellDef
                                                style="max-width: 20%">Total</mat-footer-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="AmountDR">
                                            <mat-header-cell class="grid-header" *matHeaderCellDef
                                                style="max-width: 10%">Amount(DR)</mat-header-cell>
                                            <mat-cell *matCellDef="let row" class="grid-cell" style="max-width: 10%">{{
                                                row.AmountDR
                                                }}</mat-cell>
                                            <mat-footer-cell *matFooterCellDef style="max-width: 10%">{{
                                                calculateTranTypeDR()
                                                }}</mat-footer-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="AmountCR">
                                            <mat-header-cell class="grid-header" *matHeaderCellDef
                                                style="max-width: 10%">Amount(CR)</mat-header-cell>
                                            <mat-cell *matCellDef="let row" class="grid-cell" style="max-width: 10%">{{
                                                row.AmountCR
                                                }}</mat-cell>
                                            <mat-footer-cell *matFooterCellDef style="max-width: 10%">{{
                                                calculateTranTypeCR()
                                                }}</mat-footer-cell>
                                        </ng-container>

                                        <mat-header-row *matHeaderRowDef="displayedVoucherColumns"></mat-header-row>
                                        <mat-row *matRowDef="let row; columns: displayedVoucherColumns"></mat-row>
                                        <mat-footer-row class="sticky-footer fontcolor"
                                            *matFooterRowDef="displayedVoucherColumns"></mat-footer-row>
                                    </mat-table>
                                </div>
                            </div>
                        </div>

                        <div class="row m-0">
                            <div class="col-md-12 p-1">
                                <div class="table-responsive"
                                    *ngIf="voucherMasterdata?.Voucher_Sub_Type == 'Accounting'">
                                    <mat-table [dataSource]="dataSourceVoucher" matSort matTableExporter>
                                        <ng-container matColumnDef="AccountHead">
                                            <mat-header-cell class="grid-header" *matHeaderCellDef>Account
                                                Head</mat-header-cell>
                                            <mat-cell *matCellDef="let row" class="grid-cell">{{
                                                row.ChargeHeadCategory
                                                }}</mat-cell>
                                            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="Branch">
                                            <mat-header-cell class="grid-header"
                                                *matHeaderCellDef>Branch</mat-header-cell>
                                            <mat-cell *matCellDef="let row" class="grid-cell">{{
                                                row.Branch_Name
                                                }}</mat-cell>
                                            <mat-footer-cell *matFooterCellDef>Total</mat-footer-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="AmountDR">
                                            <mat-header-cell class="grid-header"
                                                *matHeaderCellDef>Amount(DR)</mat-header-cell>
                                            <mat-cell *matCellDef="let row" class="grid-cell">{{
                                                row.AmountDR
                                                }}</mat-cell>
                                            <mat-footer-cell *matFooterCellDef>{{
                                                calculateTranTypeDR()
                                                }}</mat-footer-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="AmountCR">
                                            <mat-header-cell class="grid-header"
                                                *matHeaderCellDef>Amount(CR)</mat-header-cell>
                                            <mat-cell *matCellDef="let row" class="grid-cell">{{
                                                row.AmountCR
                                                }}</mat-cell>
                                            <mat-footer-cell *matFooterCellDef>{{
                                                calculateTranTypeCR()
                                                }}</mat-footer-cell>
                                        </ng-container>

                                        <mat-header-row *matHeaderRowDef="displayedAccountingColumns"></mat-header-row>
                                        <mat-row *matRowDef="let row; columns: displayedAccountingColumns"></mat-row>
                                        <mat-footer-row class="sticky-footer fontcolor"
                                            *matFooterRowDef="displayedAccountingColumns"></mat-footer-row>
                                    </mat-table>
                                </div>
                            </div>
                        </div>
                        <div class="row m-0 mt-2 text-left">
                            <div class="col-md-12 p-1">
                                <h6 class="fs-12">Voucher Narration</h6>
                                <p class="lead fs-12">
                                    {{ voucherMasterdata?.Voucher_Narration }}
                                </p>
                                <hr />
                            </div>
                        </div>
                        <div class="row col-md-12 mt-2 m-0 justify-content-end">
                            <button type="button" class="ml-4 mt-3 btn font-size-12 button-btn"
                                (click)="OnSaveVoucher()">
                                Save
                            </button>
                            <button type="button" class="ml-4 mt-3 btn font-size-12 button-btn"
                                (click)="OnCloseVoucher()">
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>